export default __webpack_public_path__ + "static/media/Banner 3.b2d7af46.jpg";